import { useCallback } from 'react';

import { useAdminRoute } from '@/pages/corporate/routes/hooks/useAdminRoutes';
import { ContentLockSettings, CoursePerformanceType } from '@/types/schema';

const useCourseAvailability = () => {
  const isAdminRoute = useAdminRoute();
  const getAvailability = useCallback(
    (content: any) => {
      if (isAdminRoute) {
        return true;
      }
      return content ? content.isAvailable : true;
    },
    [isAdminRoute],
  );

  const getLockSettings = useCallback(
    (lockSettings?: CoursePerformanceType['lockSettings']) => {
      if (isAdminRoute) {
        return {};
      }
      return (
        lockSettings?.reduce(
          (acc, lockSetting) => {
            acc[lockSetting.contentId] = lockSetting;
            return acc;
          },
          {} as Record<string, ContentLockSettings>,
        ) ?? {}
      );
    },
    [isAdminRoute],
  );

  return { getAvailability, getLockSettings };
};

export default useCourseAvailability;
